var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74999 6.99999H7.35499L7.21499 6.86499C7.52746 6.50197 7.75583 6.07437 7.88376 5.61279C8.01169 5.15121 8.03601 4.66706 7.95499 4.19499C7.71999 2.80499 6.55999 1.69499 5.15999 1.52499C4.6678 1.46272 4.16788 1.51387 3.6985 1.67453C3.22912 1.83519 2.80271 2.1011 2.4519 2.4519C2.1011 2.80271 1.83519 3.22912 1.67453 3.6985C1.51387 4.16788 1.46272 4.6678 1.52499 5.15999C1.69499 6.55999 2.80499 7.71999 4.19499 7.95499C4.66706 8.03601 5.15121 8.01169 5.61279 7.88376C6.07437 7.75583 6.50197 7.52746 6.86499 7.21499L6.99999 7.35499V7.74999L9.12499 9.87499C9.32999 10.08 9.66499 10.08 9.86999 9.87499C10.075 9.66999 10.075 9.33499 9.86999 9.12999L7.74999 6.99999ZM4.74999 6.99999C3.50499 6.99999 2.49999 5.99499 2.49999 4.74999C2.49999 3.50499 3.50499 2.49999 4.74999 2.49999C5.99499 2.49999 6.99999 3.50499 6.99999 4.74999C6.99999 5.99499 5.99499 6.99999 4.74999 6.99999Z",
    fill: "#546881"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.54f69b230044962e293ad446310e742f.svg";
export { ForwardRef as ReactComponent };